<template>
  <div class="mainContent">
    <div class="header">
      <img
        src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e85ec55d03/850490057.png"
        alt=""
        class="icon"
      />
      <div class="detail">
        <div class="name">
          <img
            src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624ff286dd94a/228576436.png"
            alt=""
          />
          <span>刘天启</span>
        </div>
        <div class="time">总时长: 90分钟</div>
        <div class="elapsedTime">
          <span>已用：</span>
          <span style="color: #39ab8f">{{ time }}</span>
          <el-progress
            color="#39AB8F"
            :show-text="false"
            :percentage="percentage"
            class="progress"
          ></el-progress>
        </div>
      </div>
    </div>
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      percentage: 0,
      time: 0
    };
  },
  created: function() {
    setInterval(() => {
      if (localStorage.examTime) {
        const cha = (new Date().getTime() - localStorage.examTime) / 1000
        this.time = Math.floor(cha / 60) + ':' + Math.floor(cha % 60);
        this.percentage = Math.min(cha / 60, 100);
      } else {
        localStorage.examTime = new Date().getTime()
        this.time = '00:00';
        this.percentage = 0;
      }
    }, 1000);
  },
  methods: {},
  mounted() {
    // var map = new BMap.Map("container");
    // var point = new BMap.Point(116.404, 39.915);
  }
};
</script>
<style lang="less">
.mainContent {
  background: #ebebeb;
  width: 100%;
  height: 100vh;
  padding-top: 0 !important;
  .header {
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    padding: 0 27px;
    box-sizing: border-box;
    span,
    div {
      font-size: 14px;
      font-weight: 600;
      color: #35383e;
      line-height: 1;
    }
    > img {
      width: 429px;
    }
    .detail {
      display: flex;
      align-items: center;
      .name {
        display: flex;
        align-items: center;
        > img {
          width: 20px;
          padding-right: 6px;
        }
        padding-right: 116px;
      }
      .time {
        padding-right: 116px;
      }
      .elapsedTime {
        display: flex;
        .progress {
          width: 270px;
          margin-left: 10px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .main {
    width: 100%;
    height: calc(100vh - 64px);
    background: #fff;
    border-top: 12px solid #f7f7f7;
  }
}
</style>
<style>
#newBridge {
  display: none !important;
}
</style>
